import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Producto } from 'src/app/interfaces/producto.interface';
import { VentaService } from 'src/app/services/venta.service';

@Component({
  selector: 'app-productos-sin-barra',
  templateUrl: './productos-sin-barra.component.html',
  styleUrls: ['./productos-sin-barra.component.css']
})
export class ProductosSinBarraComponent implements OnInit {

  barraForm = this.fb.group({
    barra: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public service: VentaService
  ) { }

  ngOnInit(): void {
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.barraForm.controls.barra.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.barraForm.controls.barra.setValue(cantidad);
    $('#barra').focus();
  }

  borrarDigito() {
    let cantidad: string = this.barraForm.controls.barra.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.barraForm.controls.barra.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.barraForm.controls.barra.setValue(cantidad);
  }

  enviarCodigo() {
    if (this.barraForm.invalid) {
      return;
    }

    let barra: string = this.barraForm.controls.barra.value;
    let cantidad = 1;

    const asterisco = barra.includes('*');
    if (asterisco) {
      const resultado = barra.split('*');
      cantidad = Number.parseInt(resultado[0], 10);
      barra = resultado[1];

      if (!cantidad) {
        this.toast.error('comando mal ingresado.')
        return;
      }

      if (cantidad < 1) {
        this.toast.error('comando mal ingresado.')
        return;
      }

      if (barra === '') {
        this.toast.error('comando mal ingresado.')
        return;
      }
    }

    this.service.productoPorBarra(barra + '').subscribe((productos) => {
      if (!(0 in productos)) {
        this.toast.error('Codigo producto no existe');
        this.cerrarModal();
        return;
      }

      const producto = productos[0];
      producto.name = producto.name.replace(/[üéáíóúñÑÜÁÉÍÓÚ]+/g, 'x');
      if (producto.category !== 'ABARROTES') {
        this.toast.warning(`Debe Seleccionar este producto desde menu ${producto.category}.`);
        this.cerrarModal();
        return;
      }

      this.service.agregarProductoLista(producto, cantidad);
      this.service.calcularTotal();
      this.cerrarModal();
    },
    (error) => this.toast.error(error.message)
    );
  }

  modalCodigoManual() {
    this.service.scanAuto = false;
    $('#modalCodigoManual').modal();
  }

  cerrarModal() {
    this.service.scanAuto = true;
    this.barraForm.reset();
    $('#modalCodigoManual').modal('hide');
  }

}
